import { runInAction } from "mobx";
import AppStore from "./AppStore";
import Store from "./Store";
import CustomFilterModel, { IFilter } from "../model/CustomFilterModel";

export default class FilterStore extends Store<IFilter, CustomFilterModel> {
  items = new Map<number, CustomFilterModel>();

  constructor(store: AppStore) {
    super(store);
    this.store = store;
  }

  load(items: IFilter[] = []) {
    runInAction(() => {
      items.forEach((item) =>
        this.items.set(item.id, new CustomFilterModel(this.store, item))
      );
    });
  }
}